<template>
    <div>
<!--        <div class="head_lh"></div>-->
        <div class="fxboex head">
            <div class="logo" v-if="logo"><router-link to="/"/></div>
            <template v-else>
                <div class="back backtit" @click="goBack" v-if="backTitle">{{backTitle}}</div>
                <div class="back backtit" @click="goBack" v-else>返回</div>
            </template>
            <div v-if="tablist" :class="['head_nav', logo?'head_nav_logo':'head_nav_back', backTitle?'head_nav_btit':'']">
                <van-tabs v-model="tabactiveTmp">
                    <van-tab v-for="(c, i) in tablist" :key="i" :title="c"/>
                </van-tabs>
<!--                <span v-for="(c, i) in tablist" :key="i" v-html="c" :class="['tab', tabactiveTmp===i?'tab_curr':'']" v-text="a"></span>-->
            </div>
            <div class="title" v-else>{{title}}</div>
            <div class="head_rg" v-if="logo">
                <router-link to="/my" class="tpuser" v-if="user">{{ user.name }}</router-link>
                <router-link to="/login" class="tplogin" v-else>登录/注册</router-link>
            </div>

<!--            <div class="titwel" v-if="logo">-->
<!--                <router-link to="/my" class="dk" v-if="user"><i></i>{{ user.name }}</router-link>-->
<!--                <router-link to="/login" class="l tplogin" v-else>登录/注册</router-link>-->
<!--            </div>-->

        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
    name: "title_pn",
    props: ['logo', 'title', 'path', 'tabactive', 'tablist', 'backTitle'],
    computed: mapGetters(['user']),
    data(){
        return {
            formPath: '',
            tabactiveTmp: this.tabactive,
            a: 'dd'
        }
    },
    watch: {
        tabactive(v){
          // console.log(v)
            this.tabactiveTmp = v
        },
        tabactiveTmp(v){
            // console.log(v)
            this.$emit('titleTabActive', v)
        },
        // tablist(v){
        //     console.log(v)
        // }
    },
    activated() {
        // console.log(this.tabactive)
    },
    methods: {
        goBack(){
            let that = this, path = that.path
            // console.log(path)
            if(path === undefined || path === '') {
                // console.log('back')
                that.$router.back()
            }else {
                // console.log('push')
                that.$router.replace({path: path})
            }

            // let path = that.path
            // if(path === undefined || path === '')
            //     path = '/ball'
            // // console.log(path, that.formPath)
            // that.$router.push({
            //     path: that.formPath === '' ?path:that.formPath
            // })
        },
    },
    beforeRouteEnter(to, form, next){
        next(vm => {
            vm.formPath = form.path
        })
    },
    mounted() {
        // console.log(this.formPath)
    }
}
</script>

<style scoped>
</style>
